import React, { useEffect, useState } from "react";
import StaticField from "../StaticField";
import Input from "../modules/Input";
import { useDispatch, useSelector } from "react-redux";
import {
  addEduCount,
  addEduData,
  addEduInfo,
  addEduTotal,
} from "./redux/actions";
import DropSelect from "../modules/AutoComplete";
import { modifyPage } from "../ApplicationForm/redux/actions";
import { mbaColleges, engColleges } from "../modules/CollegeList";

function EducationTop() {
  const dispatch = useDispatch();
  const status = useSelector((state) => state.status.statusData);
  const [textField, showTextField] = useState({ show: false, value: "" });
  const eduInfo = useSelector((state) => state.education);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const [cities, setCities] = useState([]);
  const [college, setCollege] = useState([]);
  const [campusList, setCampusList] = useState([]);

  const getCampusList = (value) => {
    let cityData = college.filter((a) => a["City"] === value);
    console.log("cityData in method", cityData, college, value);
    let campuses = [...cityData.map((a) => a["Campus"]), "Others"];
    console.log("campuses in method", cityData, campuses);
    dispatch(addEduData(["campusList", campuses]));
    setCampusList([...campuses]);
  };
  const addData = (type, value) => {
    let total = 0;
    if (type === "campus") {
      if (value === "Others") {
        total += 6;
        showTextField({ ...textField, show: true });
      } else {
        total += 5;

        showTextField({ ...textField, show: false });
      }
    } else if (type === "city") {
      getCampusList(value);
      // let cityData = college.filter((a) => a["City"] === value);
      // let campuses = [...cityData.map((a) => a["Campus"]), "Others"];
      // setCampusList([...campuses]);
    }
    dispatch(addEduInfo({ type: type, value: value }));
    dispatch(modifyPage("Yes"));
  };
  const getCities = () => {
    let Colleges = [];
    let degreeName = ["B.Tech", "B.E."];
    if (degreeName.includes(tokenData?.registrationData?.degree)) {
      Colleges = [...engColleges];
    } else {
      Colleges = [...mbaColleges];
    }
    let collegeData = [];
    for (let i = 0; i < Colleges.length; i++) {
      if (
        Colleges[i]["Name of university/College"]?.includes(
          tokenData.registrationData.college
        )
      ) {
        collegeData = [...collegeData, Colleges[i]];
      } else if (
        Colleges[i]["Synergy Connect name_institution"]?.includes(
          tokenData.registrationData.college
        )
      ) {
        collegeData = [...collegeData, Colleges[i]];
      }
    }
    let cityList = collegeData.map((a) => a["City"]);
    dispatch(addEduData(["cityList", cityList]));

    setCities([...cityList]);
    setCollege([...collegeData]);
  };

  useEffect(() => {
    console.log("status in edu", status);
    let edu = eduInfo.eduInfo;
    let count = 0;

    for (let i in edu) {
      if (edu[i]) {
        count += 1;
      }
    }
    if (eduInfo.eduInfo.city) {
      getCampusList(eduInfo.eduInfo.city);
    }
    dispatch(addEduCount(count));
  }, [eduInfo.eduInfo]);

  useEffect(() => {
    dispatch(addEduTotal(5));
    getCities();
    if (eduInfo.eduInfo.city) {
      getCampusList(eduInfo.eduInfo.city);
    }
  }, []);

  useEffect(() => {
    getCampusList(eduInfo.eduInfo.city);
    // let cityList = collegeData.map((a) => a["City"]);
  }, [eduInfo.eduInfo.city, eduInfo.eduInfo.campusSpecific]);

  console.log("eduInfo", eduInfo?.campusList);
  return (
    <div className="field-set edu-top ">
      {/* <div className="set-top "> */}
      {/* <div className="field"> */}

      <div className="field-row">
        <StaticField
          showTick={false}
          title={"College/Institute Name"}
          value={tokenData.registrationData.college}
        />

        {/* <div className="date-div"> */}
        <div className="input-field-item">
          <DropSelect
            onChange={(e) => addData("city", e)}
            title={"Select City"}
            value={eduInfo.eduInfo.city}
            list={cities}
          />
          {status?.eduList?.rest?.includes("city") && (
            <p style={{ color: "red" }} className="set-sub-title">
              Required
            </p>
          )}
        </div>
      </div>
      <div className="field-row">
        <StaticField
          showTick={false}
          title={`${
            !["B.Tech", "B.E."].includes(tokenData?.registrationData?.degree)
              ? "Post-"
              : ""
          }Graduation Degree Type`}
          value={tokenData.registrationData.degree}
        />
        <div className="input-field-item">
          <DropSelect
            className={`${eduInfo.eduInfo.city ? "not-disabled" : "disabled"}`}
            onChange={(e) => addData("campusSpecific", e)}
            title={"Select Campus"}
            value={eduInfo.eduInfo.campusSpecific}
            list={eduInfo?.campusList}
          />
          {status?.eduList?.rest?.includes("city") && (
            <p style={{ color: "red" }} className="set-sub-title">
              Required
            </p>
          )}
        </div>
        {/* <Input
          placeholder={"Select Campus"}
          id="panNumber"
          value={"Hsr Layout"}
          onChange={(e) => {}}

        /> */}
      </div>
      <div className="field-row">
        <StaticField
          showTick={false}
          title={"Batch Year"}
          value={tokenData.registrationData.year}
        />
        {eduInfo.eduInfo.campusSpecific === "Others" ? (
          <div className="input-field-item">
            <Input
              placeholder={"Enter Campus"}
              onChange={(e) => addData("campus", e)}
              // id={"number"}
              // inputType={"rupee"}
              value={eduInfo.eduInfo.campus}
            />
            {status?.eduList?.rest?.includes("campus") && (
              <p style={{ color: "red" }} className="set-sub-title">
                Required
              </p>
            )}
          </div>
        ) : (
          <div className="input-field-item">
            <Input
              placeholder={"Course Fee"}
              id={"number"}
              inputType={"rupee"}
              value={eduInfo.eduInfo.fee}
              onChange={(e) => addData("fee", e.replace(/\D/g, ""))}
            />
            {status?.eduList?.rest?.includes("fee") && (
              <p style={{ color: "red" }} className="set-sub-title">
                Required
              </p>
            )}
            <p className="help-text">
              The course fee must match the amount stated in the admission
              letter, which will be verified.
            </p>
          </div>
        )}
      </div>
      <div className="field-row">
        {/* <DropSelect
          onChange={(e) => addData("duration", e)}
          title={"Course Duration"}
          value={eduInfo.duration}
          list={["2 years"]}
        /> */}
        {eduInfo.eduInfo.campusSpecific === "Others" && (
          <div className="input-field-item">
            <Input
              placeholder={"Course Fee"}
              id={"number"}
              inputType={"rupee"}
              value={eduInfo.eduInfo.fee}
              onChange={(e) => addData("fee", e)}
            />
            {status?.eduList?.rest?.includes("fee") && (
              <p style={{ color: "red" }} className="set-sub-title">
                Required
              </p>
            )}
            <p className="help-text">
              The course fee must match the amount stated in the admission
              letter, which will be verified.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default EducationTop;
